import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { EligibilityPill } from "@/components/EligibilityPill";
import { MatchScore } from "@/components/MatchScore";
import { locationLabel, arrangementLabel } from "@/lib/format";
import { BookmarkSimple } from "@phosphor-icons/react";

export default function SavedJobs() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => { api.get("/saved-jobs").then((r) => setJobs(r.data.jobs)); }, []);

  return (
    <div>
      <PageHeader title="Saved jobs" subtitle="Roles you've bookmarked to revisit." />
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden" data-testid="saved-jobs-list">
        {jobs.length === 0 && (
          <div className="p-10 text-center">
            <BookmarkSimple size={32} className="mx-auto text-slate-300" />
            <p className="mt-3 text-sm text-slate-500">No saved jobs yet.</p>
            <Link to="/jobs" className="mt-3 inline-block text-sm font-medium text-slate-900 underline">Browse jobs</Link>
          </div>
        )}
        {jobs.map((j) => (
          <Link key={j.id} to={`/jobs/${j.id}`} className="flex items-center gap-4 px-5 py-4 border-b border-slate-100 last:border-0 hover:bg-slate-50 transition-colors" data-testid={`saved-${j.id}`}>
            <div className="min-w-0 flex-1">
              <p className="font-semibold text-slate-900 truncate">{j.title}</p>
              <p className="text-sm text-slate-600 truncate">{j.employer} · {locationLabel(j)} · {arrangementLabel(j.work_arrangement)}</p>
            </div>
            <EligibilityPill status={j.eligibility_status} />
            <MatchScore score={j.match_score} />
          </Link>
        ))}
      </div>
    </div>
  );
}
